module.exports = "/_next/static/images/about-feature03-ea1be32eea979557eadd81bb8e267e57.jpg";